let current_slide = 0;
const length_slideshow = document.querySelectorAll(".main-product-slideshow img").length;
const slideshow =  document.querySelector(".main-product-slideshow");
let slideshow_width = slideshow.offsetWidth;
let current_position_px = 0;

function isTouchDevice() {
  try {
    document.createEvent("TouchEvent");
    return true
  } catch (e) {
    return false
  }
};
const touchDevice = isTouchDevice();

function slide() {
  if (length_slideshow === 1) return;
  current_position_px = current_slide * slideshow_width;
  slideshow.style.transform = "translateX(-" + current_position_px + "px)";

  if (current_slide === length_slideshow - 1){
    document.querySelectorAll(".main-product-slideshow-next").forEach(element => {
      element.classList.add("disabled");
    });
    document.querySelectorAll(".main-product-slideshow-previous").forEach(element => {
      element.classList.remove("disabled");
    });
  } else if(current_slide === 0) {
    document.querySelectorAll(".main-product-slideshow-previous").forEach(element => {
      element.classList.add("disabled");
    });
    document.querySelectorAll(".main-product-slideshow-next").forEach(element => {
      element.classList.remove("disabled");
    });
  } else {
    document.querySelectorAll(".main-product-slideshow-next").forEach(element => {
      element.classList.remove("disabled");
    });
    document.querySelectorAll(".main-product-slideshow-previous").forEach(element => {
      element.classList.remove("disabled");
    });
  }
  document.querySelector("#slideshow-count").innerHTML = current_slide + 1;
}

if (touchDevice) {

  let touch_start;
  let touch_move;
  let move;
  const slideshow_container = document.querySelector(".main-product-slideshow-container.active")
  
  slideshow_container.addEventListener("touchstart", function(event) {
    touch_start = event.touches[0].pageX;
    move = 0;
    slideshow.style.transition = "none";
  });

  slideshow_container.addEventListener("touchmove", function(event) {
    touch_move = event.touches[0].pageX;
    move = (touch_start - touch_move < 30 && touch_start - touch_move > -30 ) ? '' : current_position_px + (touch_start - touch_move);
    if (current_slide === 0 && touch_start - touch_move < 0 ) return
    else if (current_slide + 1 === length_slideshow && touch_start - touch_move > 0) return
    slideshow.style.transform = "translateX(-" + move + "px)";
  });

  slideshow_container.addEventListener("touchend", function(event) {
    const touch_direction = (touch_move - touch_start > 0) ? "previous" : "next";
    if (touch_direction == "next" && current_slide + 1 != length_slideshow && move != 0){
      current_slide++;
    } else if (touch_direction == "previous" && current_slide != 0 && move != 0) {
      current_slide--;
    }
    slideshow.style.transition = "";
    slide();
  });

} else {

  document.querySelectorAll(".main-product-slideshow-next:not(.disabled)").forEach(element => {
    element.addEventListener('click', function() {
      current_slide++;
      slide();
    });
  });
  
  document.querySelectorAll(".main-product-slideshow-previous").forEach(element => {
    element.addEventListener('click', function() {
      current_slide--;
      slide();
    });
  });  

}

window.addEventListener('resize', function(event) {
  slideshow_width = slideshow.offsetWidth;
  slide();
}, true);